import React from 'react'
import { Typography } from '@mui/material'
import TimerIcon from '@mui/icons-material/Timer'
import { useWrittenTimer } from '../../hooks/useWrittenTimer'

interface WrittenTimerProps {
  auto_reply_at?: Date | null
  publication_at?: Date | null
}

export const WrittenTimer: React.FC<WrittenTimerProps> = ({ auto_reply_at, publication_at }) => {
  const { timeLeft } = useWrittenTimer({ auto_reply_at, publication_at })

  if (!timeLeft) {
    return null
  }

  return (
    <Typography color="error" fontWeight="bold" sx={{ mt: 1 }}>
      <TimerIcon sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5 }} />
      {timeLeft}
    </Typography>
  )
}